import { BLACK } from '../theme/color';

export const overrides = {
    MuiFormLabel: {
        root: {
            '&[class*="NeptuneFormLabel-secondary"]': {
                color: BLACK
            }
        }
    }
};
